import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-3c98103c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "page-container"
};
var _hoisted_2 = {
  class: "user-contest-detail-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "right-content"
};
var _hoisted_5 = {
  class: "breadcrumbs"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "mr5 ml5"
  }, "/", -1);
});
var _hoisted_7 = {
  key: 0,
  class: "title"
};
var _hoisted_8 = {
  key: 1,
  class: "title"
};
var _hoisted_9 = {
  class: "info-box"
};
var _hoisted_10 = {
  class: "item"
};
var _hoisted_11 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_12 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_13 = ["title"];
var _hoisted_14 = {
  class: "item"
};
var _hoisted_15 = {
  key: 0,
  class: "key"
};
var _hoisted_16 = {
  key: 1,
  class: "key"
};
var _hoisted_17 = {
  class: "value"
};
var _hoisted_18 = {
  class: "item"
};
var _hoisted_19 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_20 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_21 = {
  class: "value"
};
var _hoisted_22 = {
  class: "item"
};
var _hoisted_23 = {
  key: 0,
  class: "key"
};
var _hoisted_24 = {
  key: 1,
  class: "key"
};
var _hoisted_25 = {
  class: "value"
};
var _hoisted_26 = {
  class: "item"
};
var _hoisted_27 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_28 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_29 = {
  class: "value"
};
var _hoisted_30 = {
  class: "item"
};
var _hoisted_31 = {
  key: 0,
  class: "key"
};
var _hoisted_32 = {
  key: 1,
  class: "key"
};
var _hoisted_33 = {
  class: "value"
};
var _hoisted_34 = {
  class: "title"
};
var _hoisted_35 = /*#__PURE__*/_createTextVNode(" 个人信息 ");
var _hoisted_36 = {
  key: 0,
  class: "btn-box",
  style: {
    "float": "right"
  }
};
var _hoisted_37 = /*#__PURE__*/_createTextVNode(" 编辑信息 ");
var _hoisted_38 = {
  class: "info-box"
};
var _hoisted_39 = {
  key: 0,
  class: "item"
};
var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "考生id：", -1);
});
var _hoisted_41 = {
  class: "value"
};
var _hoisted_42 = {
  key: 1,
  class: "item"
};
var _hoisted_43 = {
  key: 0,
  class: "key"
};
var _hoisted_44 = {
  key: 1,
  class: "key"
};
var _hoisted_45 = {
  class: "value"
};
var _hoisted_46 = {
  key: 2,
  class: "item"
};
var _hoisted_47 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_48 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_49 = {
  class: "value"
};
var _hoisted_50 = {
  key: 3,
  class: "item"
};
var _hoisted_51 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "报名学校：", -1);
});
var _hoisted_52 = {
  class: "value"
};
var _hoisted_53 = {
  key: 4,
  class: "item"
};
var _hoisted_54 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "学员性别：", -1);
});
var _hoisted_55 = {
  class: "value"
};
var _hoisted_56 = {
  key: 5,
  class: "item"
};
var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "指导老师：", -1);
});
var _hoisted_58 = {
  class: "value"
};
var _hoisted_59 = {
  key: 6,
  class: "item"
};
var _hoisted_60 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "报名手机号：", -1);
});
var _hoisted_61 = {
  class: "text-center"
};
var _hoisted_62 = {
  key: 0
};
var _hoisted_63 = /*#__PURE__*/_createTextVNode("点击按钮查看明手机号");
var _hoisted_64 = {
  class: "phone-text"
};
var _hoisted_65 = {
  key: 1
};
var _hoisted_66 = {
  key: 7,
  class: "item"
};
var _hoisted_67 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "所在班级：", -1);
});
var _hoisted_68 = {
  class: "value"
};
var _hoisted_69 = {
  key: 8,
  class: "item"
};
var _hoisted_70 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "证件类型：", -1);
});
var _hoisted_71 = {
  class: "value"
};
var _hoisted_72 = {
  key: 9,
  class: "item"
};
var _hoisted_73 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "在考年级：", -1);
});
var _hoisted_74 = {
  class: "value"
};
var _hoisted_75 = {
  key: 10,
  class: "item"
};
var _hoisted_76 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "证件号码：", -1);
});
var _hoisted_77 = {
  class: "text-center"
};
var _hoisted_78 = {
  key: 0
};
var _hoisted_79 = /*#__PURE__*/_createTextVNode("点击按钮查看明证件号码");
var _hoisted_80 = {
  class: "phone-text"
};
var _hoisted_81 = {
  key: 1
};
var _hoisted_82 = {
  key: 11,
  class: "item"
};
var _hoisted_83 = {
  key: 0,
  class: "key"
};
var _hoisted_84 = {
  key: 1,
  class: "key"
};
var _hoisted_85 = {
  key: 2,
  class: "value"
};
var _hoisted_86 = {
  key: 3,
  class: "value"
};
var _hoisted_87 = {
  class: "item"
};
var _hoisted_88 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "证书获取方式：", -1);
});
var _hoisted_89 = {
  class: "value"
};
var _hoisted_90 = {
  key: 0,
  class: "item"
};
var _hoisted_91 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "证书邮寄地址：", -1);
});
var _hoisted_92 = {
  class: "value"
};
var _hoisted_93 = {
  key: 2,
  class: "title"
};
var _hoisted_94 = {
  key: 3,
  class: "title"
};
var _hoisted_95 = {
  class: "info-box"
};
var _hoisted_96 = {
  class: "item"
};
var _hoisted_97 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_98 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_99 = {
  class: "value"
};
var _hoisted_100 = {
  class: "item"
};
var _hoisted_101 = {
  key: 0,
  class: "key"
};
var _hoisted_102 = {
  key: 1,
  class: "key"
};
var _hoisted_103 = {
  class: "value"
};
var _hoisted_104 = {
  class: "item"
};
var _hoisted_105 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_106 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_107 = {
  class: "value"
};
var _hoisted_108 = {
  class: "item"
};
var _hoisted_109 = {
  key: 0,
  class: "key"
};
var _hoisted_110 = {
  key: 1,
  class: "key"
};
var _hoisted_111 = {
  class: "value"
};
var _hoisted_112 = {
  class: "item"
};
var _hoisted_113 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_114 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_115 = {
  class: "value"
};
var _hoisted_116 = {
  key: 0,
  class: "item"
};
var _hoisted_117 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "是否晋级：", -1);
});
var _hoisted_118 = {
  class: "value"
};
var _hoisted_119 = {
  class: "item"
};
var _hoisted_120 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "本次得分：", -1);
});
var _hoisted_121 = {
  class: "value"
};
var _hoisted_122 = {
  key: 0,
  class: "clearboth"
};
var _hoisted_123 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, null, -1);
});
var _hoisted_124 = {
  key: 1,
  class: "item item32"
};
var _hoisted_125 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "是否得奖：", -1);
});
var _hoisted_126 = {
  class: "value"
};
var _hoisted_127 = /*#__PURE__*/_createTextVNode("查看证书");
var _hoisted_128 = {
  key: 0,
  class: "clearboth"
};
var _hoisted_129 = {
  class: "item item32"
};
var _hoisted_130 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "答辩时间：", -1);
});
var _hoisted_131 = {
  class: "value"
};
var _hoisted_132 = /*#__PURE__*/_createTextVNode("开始答辩");
var _hoisted_133 = {
  key: 1
};
var _hoisted_134 = {
  key: 2,
  class: "item item32"
};
var _hoisted_135 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "赛事类型：", -1);
});
var _hoisted_136 = {
  class: "value"
};
var _hoisted_137 = /*#__PURE__*/_createTextVNode("模拟赛");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");
  var _component_a_divider = _resolveComponent("a-divider");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_popover = _resolveComponent("a-popover");
  var _component_a_tag = _resolveComponent("a-tag");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  var _component_UserCertificate = _resolveComponent("UserCertificate");
  return _ctx.userExam ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_row, {
    type: "flex",
    gutter: 44,
    wrap: false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        flex: "auto"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
            to: _ctx.myCompetionRoute,
            class: "tip"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.isNocFlag ? '我的比赛' : '我的活动'), 1)];
            }),
            _: 1
          }, 8, ["to"]), _hoisted_6, _createElementVNode("span", null, _toDisplayString(_ctx.userExam.contestInfoName), 1)]), _ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_7, "比赛信息")) : (_openBlock(), _createElementBlock("div", _hoisted_8, "活动信息")), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_11, "比赛名称：")) : (_openBlock(), _createElementBlock("div", _hoisted_12, "活动名称：")), _createElementVNode("div", {
            class: "value",
            title: "".concat(_ctx.userExam.contestInfoName)
          }, [_createElementVNode("span", null, _toDisplayString(_ctx.userExam.contestInfoName), 1)], 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_15, "比赛项：")) : (_openBlock(), _createElementBlock("div", _hoisted_16, "活动项：")), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.userExam.contestItemName), 1)]), _createElementVNode("div", _hoisted_18, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_19, "比赛类型：")) : (_openBlock(), _createElementBlock("div", _hoisted_20, "活动类型：")), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.userExam.activityTypeDesc), 1)]), _createElementVNode("div", _hoisted_22, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_23, "比赛阶段：")) : (_openBlock(), _createElementBlock("div", _hoisted_24, "活动阶段：")), _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.userExam.contestStageName || '--'), 1)]), _createElementVNode("div", _hoisted_26, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 比赛开始时间： ")) : (_openBlock(), _createElementBlock("div", _hoisted_28, "活动开始时间：")), _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.startTime)), 1)]), _createElementVNode("div", _hoisted_30, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_31, "比赛结束时间：")) : (_openBlock(), _createElementBlock("div", _hoisted_32, "活动结束时间：")), _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.endTime)), 1)])]), _createVNode(_component_a_divider, {
            style: {
              "height": "2px",
              "background-color": "#f3f5f8",
              "margin": "16px 0"
            }
          }), _createElementVNode("div", _hoisted_34, [_hoisted_35, _ctx.canShowEidtBtn ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_a_button, {
            type: "default",
            shape: "round",
            onClick: _ctx.changeInfo
          }, {
            default: _withCtx(function () {
              return [_hoisted_37];
            }),
            _: 1
          }, 8, ["onClick"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_38, [!_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.userExam.userId), 1)])) : _createCommentVNode("", true), _ctx.userExam.area !== '--' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_43, "选手所在地区：")) : (_openBlock(), _createElementBlock("div", _hoisted_44, "考生所在地区：")), _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.userExam.area.slice(0, _ctx.userExam.area.lastIndexOf('-'))), 1)])) : _createCommentVNode("", true), _ctx.userExam.userName ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_47, "选手姓名：")) : (_openBlock(), _createElementBlock("div", _hoisted_48, "考生姓名：")), _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.userExam.userName || '--'), 1)])) : _createCommentVNode("", true), _ctx.userExam.school ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.userExam.school || '--'), 1)])) : _createCommentVNode("", true), _ctx.userExam.sex && _ctx.userExam.activityId !== 259 ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_hoisted_54, _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.value2label(_ctx.userExam.sex, _ctx.SEX, '--')), 1)])) : _createCommentVNode("", true), _ctx.userExam.teacherName ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.userExam.teacherName || '--'), 1)])) : _createCommentVNode("", true), _ctx.userExam.mobile ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_hoisted_60, _ctx.userExam.mobile ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 0,
            title: "查看明文手机号",
            trigger: "click",
            onVisibleChange: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.userExamService.plainText = '';
            })
          }, {
            content: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_61, [_ctx.userExamService.plainText ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.userExamService.plainText), 1)) : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.getPlantTextString('phone');
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_63];
                }),
                _: 1
              }))])];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.userExam.mobile), 1)];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_65, "--"))])) : _createCommentVNode("", true), _ctx.userExam.className ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.userExam.className || '--'), 1)])) : _createCommentVNode("", true), _ctx.userExam.cardType && !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.value2label(_ctx.userExam.cardType, _ctx.CARD_TYPE, '--')), 1)])) : _createCommentVNode("", true), _ctx.userExam.grade ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_hoisted_73, _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.value2label(_ctx.userExam.grade, _ctx.GRADE, '--')), 1)])) : _createCommentVNode("", true), _ctx.userExam.cardNo && !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_hoisted_76, _ctx.userExam.cardNo ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 0,
            title: "查看明文证件号码",
            trigger: "click",
            onVisibleChange: _cache[3] || (_cache[3] = function ($event) {
              return _ctx.userExamService.plainText = '';
            })
          }, {
            content: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_77, [_ctx.userExamService.plainText ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.userExamService.plainText), 1)) : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.getPlantTextString('idcode');
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_79];
                }),
                _: 1
              }))])];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.userExam.cardNo), 1)];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_81, "--"))])) : _createCommentVNode("", true), _ctx.userExam.birthday && _ctx.userExam.cardType !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_83, "选手出生年月：")) : (_openBlock(), _createElementBlock("div", _hoisted_84, "考生出生年月：")), _ctx.userExam.birthday ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.userExam.birthday.substr(0, 4)) + "-" + _toDisplayString(_ctx.userExam.birthday.substr(4, 2)) + "-" + _toDisplayString(_ctx.userExam.birthday.substr(6, 2)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_86, "--"))])) : _createCommentVNode("", true), _ctx.userExam.certificateGetMethod && !_ctx.hideGetCertification && !_ctx.isNocFlag ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 12
          }, [_createElementVNode("div", _hoisted_87, [_hoisted_88, _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.value2label(_ctx.userExam.certificateGetMethod, _ctx.CERTIFICATE_GET_METHODS, '--')), 1)]), _ctx.userExam.certificatePostAddress && _ctx.userExam.certificateGetMethod === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_hoisted_91, _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.userExam.certificatePostAddress || '--'), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createVNode(_component_a_divider, {
            style: {
              "height": "2px",
              "background-color": "#f3f5f8",
              "margin": "16px 0"
            }
          }), _ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_93, "比赛信息")) : (_openBlock(), _createElementBlock("div", _hoisted_94, "活动信息")), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_97, "比赛组别：")) : (_openBlock(), _createElementBlock("div", _hoisted_98, "活动组别：")), _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.userExam.contestScheduledName), 1)]), _createElementVNode("div", _hoisted_100, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_101, "比赛开始时间：")) : (_openBlock(), _createElementBlock("div", _hoisted_102, "答题开始时间：")), _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.beginAnswerTime)), 1)]), _createElementVNode("div", _hoisted_104, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_105, "比赛耗时：")) : (_openBlock(), _createElementBlock("div", _hoisted_106, "活动耗时：")), _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.costTimeText), 1)]), _createElementVNode("div", _hoisted_108, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_109, "比赛结束时间：")) : (_openBlock(), _createElementBlock("div", _hoisted_110, "答题结束时间：")), _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.commitAnswerTime)), 1)]), _createElementVNode("div", _hoisted_112, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_113, "比赛阶段：")) : (_openBlock(), _createElementBlock("div", _hoisted_114, "活动阶段：")), _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.userExam.contestStageName || '--'), 1)]), !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_hoisted_117, _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.passedText), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_119, [_hoisted_120, _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.userExam.scoreDesc || (_ctx.userExam.totalScore === null ? '--' : _ctx.userExam.totalScore)), 1), _ctx.userExam.mockQueryScoreDesc ? (_openBlock(), _createElementBlock("div", _hoisted_122, [_hoisted_123, _createTextVNode(" " + _toDisplayString(_ctx.userExam.mockQueryScoreDesc), 1)])) : _createCommentVNode("", true)]), !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_124, [_hoisted_125, _createElementVNode("div", _hoisted_126, [_createElementVNode("span", null, _toDisplayString(_ctx.awardedText), 1), _ctx.userExam.awarded === 2 && _ctx.userExam.certiPicture ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "default",
            shape: "round",
            class: "ml8",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return _ctx.showUserCertificate.visible = true;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_127];
            }),
            _: 1
          })) : _createCommentVNode("", true)]), _ctx.userExam.mockQueryScoreDesc ? (_openBlock(), _createElementBlock("div", _hoisted_128)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_129, [_hoisted_130, _createElementVNode("div", _hoisted_131, [_ctx.userExam.defenceStatus === 2 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            shape: "round",
            class: "ml8",
            onClick: _ctx.goToExamAnswer
          }, {
            default: _withCtx(function () {
              return [_hoisted_132];
            }),
            _: 1
          }, 8, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_133, _toDisplayString(_ctx.userExam.defenceTimePeriod || '--'), 1))])]), _ctx.userExam.examType === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_134, [_hoisted_135, _createElementVNode("div", _hoisted_136, [_createVNode(_component_a_tag, {
            class: "pos-tag",
            color: "#fc5000"
          }, {
            default: _withCtx(function () {
              return [_hoisted_137];
            }),
            _: 1
          })])])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]), _ctx.userExam.userExamId ? (_openBlock(), _createBlock(_component_UserCertificate, {
    key: _ctx.userExam.userExamId,
    show: _ctx.showUserCertificate,
    userExamId: _ctx.userExam.userExamId
  }, null, 8, ["show", "userExamId"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}